import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  loading: boolean;
  loadingChange: Subject<boolean> = new Subject<boolean>();
  constructor() {
    this.loadingChange.subscribe((value) => {
      this.loading = value;
    });
  }

  changeLoadingVisibility(value) {
    this.loadingChange.next(value);
  }
}
